<template>
  <div>
    <div :class="{ 'outer-div-background': background }">
      <v-container>
        <!-- Toolbar for xs devices -->
        <div
          v-if="$vuetify.breakpoint.xsOnly"
          class="d-flex align-center justify-center"
        >
          <v-app-bar-nav-icon
            absolute
            dark
            @click="$store.state.navDrawer = true"
          ></v-app-bar-nav-icon>
          <router-link class="logo-wrapper justify-center" to="/">
            <v-avatar class="mr-3"
              ><v-img src="@/assets/logo/logo.png"></v-img
            ></v-avatar>
            <span>National Prion Monitoring Cohort</span>
          </router-link>
        </div>

        <!-- Toolbar for other devices -->
        <div v-else>
          <v-row class="align-center" no-gutters>
            <!-- Logo -->
            <router-link class="logo-wrapper" to="/">
              <v-avatar size="55" class="elevation-6 mr-2"
                ><v-img src="@/assets/logo/logo.png"></v-img
              ></v-avatar>
              <span>National Prion Monitoring Cohort</span>
            </router-link>

            <v-spacer></v-spacer>

            <v-menu v-if="user" offset-y bottom transition="slide-y-transition">
              <template v-slot:activator="{ on }">
                <div class="userDropdown" v-on="on">
                  <v-icon>
                    mdi-account
                  </v-icon>
                  <p class="ml-2">
                    {{ user.name | getFirstLetter }}. {{ user.surname }}
                  </p>
                  <v-icon>
                    mdi-menu-down
                  </v-icon>
                </div>
              </template>

              <v-list>
                <v-list-item
                  key="1"
                  @click="$store.state.resetPasswordDialog = true"
                >
                  <v-list-item-title>
                    Change password
                  </v-list-item-title>
                </v-list-item>
                <v-list-item key="2" @click="logout">
                  <v-list-item-title>
                    Sign out
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>

            <!--Show login and signup buttons if user is not logged in-->
            <router-link v-else to="/signin" class="sign-in-div">
              Sign in
            </router-link>
          </v-row>
        </div>
      </v-container>
    </div>

    <!-- Navigation Links -->
    <div
      v-if="$vuetify.breakpoint.smAndUp"
      class="navigation-links"
      :class="{ 'navigation-background': background }"
    >
      <v-container class="py-0">
        <v-row no-gutters>
          <router-link
            v-for="link in navigationLinks"
            :key="link.title"
            :to="link.to"
          >
            {{ link.title }}
          </router-link>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<style scoped>
.outer-div-background {
  background: var(--v-primary-base);
  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14),
    0 1px 10px 0 rgba(0, 0, 0, 0.12);
}

.v-app-bar__nav-icon {
  top: 20px;
  left: 15px;
  position: absolute;
}

/* ---- Navigation Links ---- */

.navigation-links a {
  line-height: 30px;
  text-decoration: none;
  padding-top: 8px;
  padding-bottom: 8px;
  padding-right: 12px;
  padding-left: 12px;
  transition: background-color ease 0.2s;
  color: white;
}

.navigation-links a:hover {
  background-color: var(--v-accent-base);
  color: white;
}

.navigation-background {
  background-color: #e0f7fa;
}

.navigation-background a {
  color: var(--v-primary-darken4);
}

/* ---- Logo ---- */
.logo-wrapper {
  display: flex;
  align-items: center;
  text-decoration: none;
}

.logo-wrapper span {
  font-size: 25px;
  margin-left: 6px;
  color: white;
  font-family: "Montserrat", "Roboto", sans-serif;
}

@media (max-width: 600px) {
  .logo-wrapper span {
    font-size: 16px;
    width: 50%;
  }
}

/* ---- User dropdown ---- */
.userDropdown p {
  display: inline;
}

.userDropdown p:hover {
  text-decoration: underline;
}

.userDropdown {
  cursor: pointer;
  color: white;
}
.userDropdown i {
  color: white;
}

@media (max-width: 600px) {
  .userDropdown p {
    font-size: 14px;
  }
}

/* ---- Sign in div ---- */

.sign-in-div {
  color: white;
  cursor: pointer;
  text-decoration: none;
}
.sign-in-div:hover {
  color: var(--v-primary-lighten2);
}
</style>

<script>
import { mapState } from "vuex";

export default {
  props: {
    background: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapState(["user", "navigationLinks"]),
    logoWidth() {
      if (this.$vuetify.breakpoint.xsOnly) {
        return "250";
      } else {
        return "500";
      }
    }
  },
  methods: {
    logout() {
      if (this.$route.path !== "/") {
        this.$router.push("/");
      }
      this.$store.dispatch("userLogout");
    }
  },
  filters: {
    getFirstLetter: function(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase();
    }
  }
};
</script>
